let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hsNGG")).then(() => parcelRequire('36V1P'));